import React, { useCallback, useEffect, useRef, useState } from "react";
import { StyledInput } from "../../../auth/section/auth.styled";
import { MdSend } from "react-icons/md";
import { Message } from "../../../../api/message-request";
import { useChatSocket } from "../../../../socket/use-chat-socket";
import { Box, styled, Theme, useTheme } from "@mui/material";
import { useCurrentUser } from "../../../../api-hooks/use-current-user";
import { useSelectedUser } from "../../../../api-hooks/use-selected-user";

type ChatDetailBottomBarProps = {
  messageSentCallback: (message: Message) => void;
};

const StyledInputContainer = styled(Box)(({ theme }: { theme: Theme }) => ({
  flex: 1,
  boxSizing: "border-box",
  padding: "0.8rem",
  transition: "all 0.5s",
  borderRadius: "0.5rem",
  backgroundColor: theme.palette.primary.contrastText,
}));

const StyledBottomBar = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  position: "absolute",
  bottom: 0,
  backgroundColor: theme.palette.grey.A200,
  right: 0,
  left: 0,
  padding: "0.8rem",
  height: "80px",
  columnGap: "10px",
}));

const ChatDetailBottomBar: React.FC<ChatDetailBottomBarProps> = ({
  messageSentCallback,
}) => {
  const theme = useTheme();
  const { user: loginUser } = useCurrentUser();
  const { selectedUser } = useSelectedUser();
  const [message, setMessage] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);

  const { sendMessage } = useChatSocket(messageSentCallback);

  const handleSend = useCallback(() => {
    if (loginUser && selectedUser) {
      sendMessage({
        senderId: loginUser.id,
        receiverId: selectedUser.userId,
        text: message,
      });
    }
    setMessage("");
  }, [loginUser, message, sendMessage, selectedUser]);

  useEffect(() => {
    inputRef.current?.focus();
  }, [selectedUser]);

  return (
    <StyledBottomBar>
      <StyledInputContainer>
        <StyledInput
          ref={inputRef}
          value={message}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          onChange={(event) => setMessage(event.target.value)}
          placeholder="Type a message here"
        />
      </StyledInputContainer>
      <MdSend
        onClick={handleSend}
        size={30}
        color={theme.palette.primary.main}
      />
    </StyledBottomBar>
  );
};

export default ChatDetailBottomBar;
